import type { HTMLAttributes } from "react";
import clsx from "clsx";

export type BadgeTone = "neutral" | "accent" | "success" | "warning" | "danger";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

const toneClasses: Record<BadgeTone, string> = {
  neutral: "bg-surface text-ink-muted border-border",
  accent: "bg-accent-soft text-accent-strong border-transparent",
  success: "bg-emerald-500/10 text-emerald-600 border-transparent dark:text-emerald-400",
  warning: "bg-amber-500/10 text-amber-600 border-transparent dark:text-amber-400",
  danger: "bg-red-500/10 text-red-600 border-transparent dark:text-red-400"
};

export function Badge({ className, tone = "neutral", ...props }: BadgeProps) {
  return (
    <span
      className={clsx(
        "inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium tracking-tight",
        toneClasses[tone],
        className
      )}
      {...props}
    />
  );
}
